export enum ReferenceNumberTypeDomestic {
    P40_SALES_ORDER_NUMBER = 'P40 - Sales Order Number',
    P40_PURCHASE_ORDER_NUMBER = 'P40 - Purchase Order Number',
    P41_SALES_ORDER_NUMBER = 'P41 - Sales Order Number',
    P41_DELIVERY_NUMBER = 'P41 - Delivery/Shipment Number',
    HANDLING_UNIT = 'Handling Unit',
    TRANSPORT_UNIT = 'Transport Unit'
}
